import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { Lock, Zap, ShieldCheck, ArrowRight, Clock, CreditCard } from 'lucide-react';
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'pro'>('pro');
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24, 0, 0);
  return <section id="pricing" className="bg-lsa-deep text-white py-16 px-5 border-t border-white/10" data-id="element-180">
      <div className="max-w-xl mx-auto" data-id="element-181">
        {/* BIG TIMER */}
        <div className="mb-12 flex flex-col items-center" data-id="element-182">
          <p className="text-lsa-cyan font-bold text-sm tracking-widest mb-4 uppercase flex items-center gap-2" data-id="element-183">
            <Clock size={16} data-id="element-184" /> Esta oferta termina en
          </p>
          <div className="flex items-center gap-3 sm:gap-4" data-id="element-185">
            <div className="flex flex-col items-center" data-id="element-186">
              <div className="bg-[#0E1730] border border-white/10 rounded-xl w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center text-[32px] sm:text-[40px] font-bold shadow-inner" data-id="element-187">
                {hours}
              </div>
              <span className="text-[10px] sm:text-xs text-white/50 mt-2 font-semibold tracking-wider" data-id="element-188">
                HORAS
              </span>
            </div>
            <div className="text-2xl font-bold text-lsa-cyan/50 -mt-6" data-id="element-189">:</div>
            <div className="flex flex-col items-center" data-id="element-190">
              <div className="bg-[#0E1730] border border-white/10 rounded-xl w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center text-[32px] sm:text-[40px] font-bold shadow-inner" data-id="element-191">
                {minutes}
              </div>
              <span className="text-[10px] sm:text-xs text-white/50 mt-2 font-semibold tracking-wider" data-id="element-192">
                MIN
              </span>
            </div>
            <div className="text-2xl font-bold text-lsa-cyan/50 -mt-6" data-id="element-193">:</div>
            <div className="flex flex-col items-center" data-id="element-194">
              <div className="bg-[#0E1730] border border-white/10 rounded-xl w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center text-[32px] sm:text-[40px] font-bold shadow-inner text-lsa-cyan" data-id="element-195">
                {seconds}
              </div>
              <span className="text-[10px] sm:text-xs text-white/50 mt-2 font-semibold tracking-wider" data-id="element-196">
                SEG
              </span>
            </div>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-197">
          <h2 className="text-[28px] sm:text-[32px] font-extrabold mb-2 tracking-tight" data-id="element-198">
            ELEGÍ TU <span className="text-lsa-cyan" data-id="element-199">SISTEMA LSA FÁCIL</span>
          </h2>
          <p className="text-white/60 text-[15px] font-medium" data-id="element-200">
            Ambas opciones incluyen los 6 bonos completos
          </p>
        </div>

        {/* PLAN SELECTOR */}
        <div className="flex flex-col gap-4 mb-8" data-id="element-201">
          {/* Option 1: Base */}
          <div onClick={() => setSelectedPlan('base')} className={`relative cursor-pointer rounded-2xl p-5 transition-all duration-200 border-2 ${selectedPlan === 'base' ? 'border-lsa-cyan bg-[#0E1730]' : 'border-white/10 bg-[#0E1730]/40 hover:bg-[#0E1730]/70'}`} data-id="element-202">
            <div className="flex items-start gap-4" data-id="element-203">
              <div className="mt-1 shrink-0" data-id="element-204">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'base' ? 'border-lsa-cyan' : 'border-white/30'}`} data-id="element-205">
                  {selectedPlan === 'base' && <div className="w-3 h-3 rounded-full bg-lsa-cyan" data-id="element-206" />}
                </div>
              </div>
              <div className="flex-1" data-id="element-207">
                <h3 className="font-bold text-[18px] mb-1 flex items-center gap-2" data-id="element-208">
                  <span data-id="element-209">🤟</span> SISTEMA LSA FÁCIL
                </h3>
                <p className="text-white/70 text-[14px] mb-3" data-id="element-210">
                  7 tomos + 6 bonos estratégicos
                </p>
                <div className="flex items-end gap-3" data-id="element-211">
                  <span className="text-white/50 line-through text-[15px] mb-0.5" data-id="element-212">
                    $49.000
                  </span>
                  <span className="text-[24px] font-bold leading-none" data-id="element-213">
                    $19.990
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Pro */}
          <div onClick={() => setSelectedPlan('pro')} className={`relative cursor-pointer rounded-2xl p-5 transition-all duration-200 border-2 ${selectedPlan === 'pro' ? 'border-lsa-cyan bg-[#0E1730] shadow-[0_0_24px_rgba(25,199,232,0.18)]' : 'border-white/10 bg-[#0E1730]/40 hover:bg-[#0E1730]/70'}`} data-id="element-214">
            <div className="flex items-start gap-4" data-id="element-215">
              <div className="mt-1 shrink-0" data-id="element-216">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'pro' ? 'border-lsa-cyan' : 'border-white/30'}`} data-id="element-217">
                  {selectedPlan === 'pro' && <div className="w-3 h-3 rounded-full bg-lsa-cyan" data-id="element-218" />}
                </div>
              </div>
              <div className="flex-1" data-id="element-219">
                <h3 className="font-bold text-[18px] mb-2 flex items-center gap-2 text-lsa-cyan" data-id="element-220">
                  <span data-id="element-221">🚀</span> PLAN PROFESIONAL
                </h3>
                <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-222">
                  <span className="bg-lsa-cyan text-lsa-deep text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-223">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-500/20 text-green-400 text-[11px] font-bold px-2 py-0.5 rounded" data-id="element-224">
                    AHORRÁS $41.000
                  </span>
                </div>
                <p className="text-white/70 text-[14px] mb-3" data-id="element-225">
                  7 tomos + 6 bonos{' '}
                  <span className="text-white font-semibold" data-id="element-226">
                    + 4 módulos profesionales
                  </span>
                </p>
                <div className="flex items-end gap-3" data-id="element-227">
                  <span className="text-white/50 line-through text-[15px] mb-0.5" data-id="element-228">
                    $69.000
                  </span>
                  <span className="text-[24px] font-bold leading-none text-lsa-cyan" data-id="element-229">
                    $27.990
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA BUTTON */}
        <button onClick={() => {
        window.location.href = selectedPlan === 'pro' ? 'https://checkout.tusbeneficios.shop/cart/51269870846185:1' : 'https://checkout.tusbeneficios.shop/cart/51269870780649:1';
      }} className="w-full bg-lsa-cyan hover:brightness-110 text-lsa-deep h-[64px] rounded-xl font-bold text-[18px] transition-all shadow-lg shadow-lsa-cyan/30 flex items-center justify-center gap-2 mb-3" data-id="element-230">
          SÍ, QUIERO EL{' '}
          {selectedPlan === 'pro' ? 'PLAN PROFESIONAL' : 'SISTEMA BASE'}{' '}
          <ArrowRight size={20} data-id="element-231" />
        </button>

        <p className="text-center text-white/50 text-[13px] italic mb-8" data-id="element-232">
          {selectedPlan === 'pro' ? 'La opción más elegida por quienes quieren comunicarse de verdad' : 'El plan perfecto para empezar desde cero absoluto'}
        </p>

        {/* TRUST BAR */}
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-[13px] text-lsa-cyan/80 font-medium mb-4" data-id="element-233">
          <div className="flex items-center gap-1.5" data-id="element-234">
            <Lock size={14} data-id="element-235" /> Pago seguro
          </div>
          <div className="flex items-center gap-1.5" data-id="element-236">
            <Zap size={14} data-id="element-237" /> Acceso inmediato
          </div>
          <div className="flex items-center gap-1.5" data-id="element-238">
            <ShieldCheck size={14} data-id="element-239" /> Garantía 7 días
          </div>
        </div>

        <div className="flex justify-center items-center gap-1.5 text-[13px] text-white/50 font-medium" data-id="element-240">
          <CreditCard size={14} data-id="element-241" /> Astro Pay
        </div>
      </div>
    </section>;
}